exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.banner-sec-main[data-v-1dfa0be4] {\n  background-image: url(\"/images/privacy-policy-bg-img.png\" );\n  min-height: clamp(500px,50vw,800px);\n  background-size: cover;\n  background-position: center center;\n  background-repeat: no-repeat;\n}\n.brands-logos .swiper-wrapper[data-v-1dfa0be4] {\n  align-items: center !important;\n}\n.fs-60[data-v-1dfa0be4] {\n  font-size: clamp(32px, 4vw, 60px);\n}\n", ""]);

// exports
